/* tslint:disable */
import { ConfigurationModel } from './configuration-model';
import { IOverrides, IConfigurationModel } from '../interfaces';
import { toValuesTree, toOverrides } from '../utils';
import * as json from '@vscode/base-node/vs/base/common/json';

export class ConfigurationModelParser {

    private _configurationModel: ConfigurationModel | null = null;
    private _parseErrors: any[] = [];

    constructor(protected readonly _name: string) { }

    get configurationModel(): ConfigurationModel {
        return this._configurationModel || new ConfigurationModel();
    }

    get errors(): any[] {
        return this._parseErrors;
    }

    public parse(content: string): void {
        const raw = this.parseContent(content);
        const configurationModel = this.parseRaw(raw);
        this._configurationModel = new ConfigurationModel(configurationModel.contents, configurationModel.keys, configurationModel.overrides);
    }

    protected parseContent(content: string): any {
        let raw: any = {};
        let currentProperty: string | null = null;
        let currentParent: any = [];
        let previousParents: any[] = [];
        let parseErrors: json.ParseError[] = [];

        function onValue(value: any) {
            if (Array.isArray(currentParent)) {
                (<any[]>currentParent).push(value);
            } else if (currentProperty) {
                currentParent[currentProperty] = value;
            }
        }

        let visitor: json.JSONVisitor = {
            onObjectBegin: () => {
                let object = {};
                onValue(object);
                previousParents.push(currentParent);
                currentParent = object;
                currentProperty = null;
            },
            onObjectProperty: (name: string) => {
                currentProperty = name;
            },
            onObjectEnd: () => {
                currentParent = previousParents.pop();
            },
            onArrayBegin: () => {
                let array: any[] = [];
                onValue(array);
                previousParents.push(currentParent);
                currentParent = array;
                currentProperty = null;
            },
            onArrayEnd: () => {
                currentParent = previousParents.pop();
            },
            onLiteralValue: onValue,
            onError: (error: json.ParseErrorCode, offset: number, length: number) => {
                parseErrors.push({ error, offset, length });
            }
        };
        if (content) {
            try {
                json.visit(content, visitor);
                raw = currentParent[0] || {};
            } catch (e) {
                console.error(`Error while parsing settings file ${this._name}: ${e}`);
                this._parseErrors = [e];
            }
        }

        return raw;
    }

    protected parseRaw(raw: any): IConfigurationModel {
        const contents = toValuesTree(raw, message => console.error(`Conflict in settings file ${this._name}: ${message}`));
        const keys = Object.keys(raw);
        const overrides: IOverrides[] = toOverrides(raw, message => console.error(`Conflict in settings file ${this._name}: ${message}`));
        return { contents, keys, overrides };
    }
}